// extracted by mini-css-extract-plugin
export default {"Login_link":"AwsAuth_Login_link__HcsyS"};